;(function(window, document, $) {
   $('#reward-reg').on('click',function(){
        $.ajax({
            url:'http://activity.polyv.net/ticket/17-10/1/add',
            dataType: 'jsonp',
            data:{ticketName:'注册免费礼'}
        }).done(function(res){
            // console.log('res: '+JSON.stringify(res));
            if(res.status == 'error'){
                if(res.message == '您已经领取过该礼物'){
                    // console.log(res.message);
                    // $('#login-reward,.js-mask').show();
                    // $('.received').html('您已领取过了,<br />赶快登录POLYV后台来体验直播吧！');
                }else if(res.message == '登录后才能领取礼物'){
                    $('#please-login,.js-mask').show();
                }else {
                    $('.error-message').text(res.message);
                    $('#new-user,.js-mask').show();
                }
            }else if(res.status == 'success'){
                $('#login-reward,js-mask').show();
                $('#reward-reg').attr('disabled','disabled').css({'background-color':'grey','box-shadow':'none','cursor':'default'}).text('已领取');
            }
        })
   });

   $('#btn-login').on('click',function(){
        $('#loginmodal,.js-mask').show();
        $('#please-login').hide();
    })

   $('.close,.modal-close,.n-login,#blank-polyv').on('click',function(){
        $('.login-prompt,.js-mask').hide();
   })
})(window, document, jQuery);